// extracted by mini-css-extract-plugin
export default {"SegmentedInput":"SegmentedInput_SegmentedInput__VTDze","segment":"SegmentedInput_segment__Vk--h"};